import { render, staticRenderFns } from "./AttachmentDownload.vue?vue&type=template&id=56b38214&scoped=true"
import script from "./AttachmentDownload.vue?vue&type=script&lang=js"
export * from "./AttachmentDownload.vue?vue&type=script&lang=js"
import style0 from "./AttachmentDownload.vue?vue&type=style&index=0&id=56b38214&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56b38214",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/MAIS/MAIS/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('56b38214')) {
      api.createRecord('56b38214', component.options)
    } else {
      api.reload('56b38214', component.options)
    }
    module.hot.accept("./AttachmentDownload.vue?vue&type=template&id=56b38214&scoped=true", function () {
      api.rerender('56b38214', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/AttachmentDownload.vue"
export default component.exports